import * as React from "react";
import { ODataParams, Query } from "../Components/Query";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../misc/api/WebPortalTokenClient";
import DocumentTitle from "../misc/components/DocumentTitle";
import { SessionsListTable } from "./SessionsListTable";

export const SessionsListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getSessions("id,visit,name,sessionTypeName,sessionType,technician,occurred,lastReceived,analysisSets", filter, params.orderby, 'visit($select=id,subject,name;$expand=subject($select=id,site,number,typeKey;$expand=site($select=id,number))),analysisSets($select=id,type,status)', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Sessions List | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc"}]}>
                <SessionsListTable />
            </Query>
        </DocumentTitle>
    );
}
